import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.css'],
    standalone: false
})
export class AdminLayoutComponent implements OnInit{

  isSideNavOpeon : boolean = false;

  ngOnInit(): void {
  }

  openSideNav(){
    this.isSideNavOpeon = true;
  }

}
